import React, { useState } from "react"
import Proptypes from "prop-types"
import { Button } from "reactstrap"
import { Modal } from "react-bootstrap"
import ContactUs from "../../ContactUs/contactUs"

const IntroPricing = props => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const closeContactus = () => setShow(false)

  return (
    <div
      className="intro-pricing"
      style={{ backgroundImage: `URL(${props.background})` }}
    >
      <h1 className="title">{props.title}</h1>
      <div className="description">{props.description}</div>
      <div className="button-container">
        {props.blueTitle ? (
          <Button
            className="small-font"
            outline
            color="green"
            onClick={handleShow}
          >
            {props.blueTitle}
          </Button>
        ) : (
          ""
        )}
        {props.yellowTitle ? (
          <Button
            className="small-font"
            outline
            color="yellow"
            href={props.yellowLink}
            target="blank"
          >
            {props.yellowTitle}
          </Button>
        ) : (
          ""
        )}
      </div>
      {/* <img className="backgroud-image" alt="Meetrix.IO Jitsi Meet consultation service is the most experienced Jitsi Meet consultation service" src={props.background} /> */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton />
        <ContactUs closeContactus={closeContactus} />
      </Modal>
    </div>
  )
}

IntroPricing.prototype = {
  title: Proptypes.any,
  description: Proptypes.any,
  blueTitle: Proptypes.any,
  blueLink: Proptypes.any,
  yellowTitle: Proptypes.any,
  yellowLink: Proptypes.any,
  background: Proptypes.any,
}

export default IntroPricing
